import React from 'react'
import cx from 'classnames'
import { Icon, Text } from '@components/UI'

const Upload = ({ text, onClick, className }) => {
  return (
    <div className={cx('gp-upload', className)} onClick={onClick}>
      <Icon name='upload fill' />
      <Text className='semibold'>{text}</Text>
    </div>
  )
}

Upload.defaultProps = {
  text: `Drag and drop files right here, and we’ll upload them for you`,
  onClick: () => {},
  className: ''
}

export default Upload
